// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"806":"5725de90","869":"e7b25051","931":"6eeac184"}[chunkId] + ".css";
};